import { VOImage, VOHomeElement } from "../../model/DataStructure.js";
import { Home } from "../Home.js";
import { HtmlImageItem } from "./HtmlImageItem.js";
import { Editor } from "../Editor.js";

export class EditingImageItem extends HtmlImageItem {

    private _drag: e5.Drag;

    constructor(private _home: Home, private _editor: Editor, image: VOImage, screenWidth: number) {
        super(image, screenWidth);

        this.element.classList.add("editing");

        this.killAnimation();

        this._drag = new e5.Drag(this.element, {
            stopPropagation: true
        });

        var move = 0;
        e5.Player.onTick.add(() => {
            if (!move)
                return;
            this._home.x += move;
        });

        var click = new e5.Click(this.element);
        click.onClick.add(() => {
            this._editor.select(this.image as VOHomeElement);
        });

        this._drag.onDown.add(() => {
            if (this._drag.pointers.length != 1)
                return;

            this._home.element.querySelector("#map").classList.toggle("show-boundaries", true);
            this.element.classList.add("drag");

            // this._editor.select(this.image as VOHomeElement);
        });

        this._drag.onMove.add(() => {
            var position = this._drag.position;
            //var x = position.x - this._home.x;

            var scale = 0.3;
            if (position.x < 0) {
                move = Math.abs(position.x) * scale;
            } else if (position.x > (screenWidth - image.image.width)) {
                move = -Math.abs((screenWidth - image.image.width) - position.x) * scale;
            } else {
                move = 0;
            }

        });

        this._drag.onClear.add(() => {
            move = 0;

            var position = this._drag.position;
            image.x = position.x - this._home.x;
            image.y = position.y;

            // var homeCategory = this._home.getNearesHomeCategory(image.x);
            var homeCategory = this._home.getHomeCategoryByPosition(-(image.x + image.image.width * 0.5) + this.screenWidth * 0.5);

            // var homeCategory = this._home.getCurrentHomeCategory();
            var tx = homeCategory.targetX - (homeCategory.targetX - this._home.x);

            // var tx = this._home.x;

            var x = image.x;
            var z = image.z;
            image.x = (tx + x) - (tx / z);

            // this.left = image.x;
            // this.top = image.y;
            // this.right = this.left + this.width;
            // this.bottom = this.top + this.height;

            // console.log(x, image.y);
            // console.log(homeCategory.home_category.title);

            (image as VOHomeElement).category = homeCategory;

            this._home.element.querySelector("#map").classList.toggle("show-boundaries", false);
            this.element.classList.remove("drag");
            this._home.tweenToHomeCategory(homeCategory);
        });
    }

    public remove(): void {
        this.element.remove();
    }

    protected setVisibility(visible: boolean): void {
        if (this._drag.pointers.length > 0)
            return;
        this.element.classList.toggle("hidden", !visible);
    }

    protected setTransform(x: number, y: number, scale: number): void {
        if (this._drag.pointers.length > 0)
            return;
        this.element.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
    }

    public get selected(): boolean {
        return this.element.classList.contains("selected");
    }

    public set selected(selected: boolean) {
        this.element.classList.toggle("selected", selected);
    }
}